import './styles.scss';

import React, {CSSProperties, PropsWithChildren} from 'react';

interface AppTitleProps extends PropsWithChildren {
    style?: CSSProperties;
}

export const AppTitle = ({style, children}: AppTitleProps) => {
    return (
        <h3 className='app-title' style={style}>
            {children}
        </h3>
    );
};
